/** @jsxImportSource @emotion/react */
'use memo'

import styled from '@emotion/styled'
import colors from '@sportninja/common/constants/appColors'
import { paragraphSmall } from 'src/components/css'

interface Props {
  /** The first line — a date, or a window's start. */
  first: string
  /** The window's end, under the start with its dash; '' for a single date. */
  second?: string
}

/**
 * A date, or a date range split over two lines so the column stays narrow.
 * A dash when there is no date.
 */
const DateLinesCell = ({ first, second = '' }: Props) => {
  'use memo'

  return (
    <Wrapper>
      <span>{first ? `${first}${second ? ' –' : ''}` : '—'}</span>
      {first && second ? <span>{second}</span> : null}
    </Wrapper>
  )
}

export default DateLinesCell

const Wrapper = styled.div`
  ${paragraphSmall}
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 100%;
  line-height: 1.4;
  white-space: nowrap;
  color: ${colors.WHITE};
`
